import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Service } from '../../types/content';
type ServiceCardProps = {
  service: Service;
};
export function ServiceCard({
  service
}: ServiceCardProps) {
  const Icon = service.icon;
  return <article className="flex h-full flex-col bg-white p-8 lg:p-10" data-id="element-362" data-mp="15161gim6k1w3">
      <span className="flex h-11 w-11 items-center justify-center border border-gold/60 text-gold-deep" data-id="element-363" data-mp="152z9a18j4s5o">
        <Icon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-364" data-mp="vatk0z9nwou6" />
      </span>
      <h3 className="mt-8 font-serif text-[1.65rem] font-medium leading-[1.2] text-navy sm:min-h-[2.4em]" data-id="element-365" data-mp="v8qknommdjcs">
        {service.title}
      </h3>
      <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-366" data-mp="maollemg50s5">{service.summary}</p>
      <Link to={`/services#${service.id}`} className="group mt-auto inline-flex items-center gap-2 self-start pt-8 text-sm font-medium text-navy underline-offset-4 hover:underline" data-id="element-367" data-mp="hasiriphjfe6">
        Learn More<span className="sr-only" data-id="element-368" data-mp="77z7pl754u5o"> about {service.title}</span>
        <ArrowRightIcon className="h-4 w-4 text-gold-deep transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-369" data-mp="76ecrugwz97a" />
      </Link>
    </article>;
}